module.exports = __webpack_public_path__ + "media/images/general/ogp-e90e26e7d3f30f9d146246ad21d9355b.png";